import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NAVIGATION_CONFIG } from '../utils/navigationConfig';
import { getThreediumPlatformOrigin } from '../utils/threediumPlatform';

const ENGINE_LINKS = [
  { title: 'Threedium Launchpad', subtitle: 'Your starting point', path: '/app/launchpad' },
  { title: '3D Editor', subtitle: 'Interact with 3D models', path: NAVIGATION_CONFIG.PROJECTS.path },
  { title: 'Julian NXT', subtitle: 'Generate 3D models', path: '/ai-studio' },
];

// Same menu as the Threedium website navbar. Coding Agents is this app, so it stays an in-app link.
function EngineMenu({ onBackToDashboard, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const platformOrigin = getThreediumPlatformOrigin();

  // close the dropdown on click outside of it
  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (!e.target.closest('[data-engine-menu]')) setIsOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);

  return (
    <div data-engine-menu className="header-engine-menu">
      <button
        type="button"
        className="header-engine-menu-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>Coding Agents</span>
        <ChevronDownIcon isOpen={isOpen} />
      </button>

      {isOpen && (
        <ul className="header-engine-dropdown">
          {ENGINE_LINKS.map((link) => (
            <li key={link.title}>
              <a
                className="header-engine-item"
                href={`${platformOrigin}${link.path}`}
                onClick={() => setIsOpen(false)}
              >
                {link.title}
                <span className="header-engine-item-subtitle">{link.subtitle}</span>
              </a>
            </li>
          ))}
          <li>
            <Link
              to="/dashboard"
              className="header-engine-item selected"
              onClick={(e) => {
                setIsOpen(false);
                if (onBackToDashboard) {
                  e.preventDefault();
                  onBackToDashboard();
                }
              }}
            >
              Coding Agents
              <span className="header-engine-item-subtitle">Build with AI agents</span>
            </Link>
          </li>
        </ul>
      )}
    </div>
  );
}

function ChevronDownIcon({ isOpen }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: isOpen ? 'rotate(180deg)' : undefined }}
    >
      <path d="M4 6L8 10L12 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default EngineMenu;
